import { render, staticRenderFns } from "./ResultsPanel.vue?vue&type=template&id=7c18d7d6&scoped=true&"
import script from "./ResultsPanel.vue?vue&type=script&lang=ts&"
export * from "./ResultsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c18d7d6",
  null
  
)

export default component.exports